import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";

import { roles } from "utils/misc";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class KeyDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            name: "",
            key_hash: "",
            balance: 0,
            liter_price: "",
            telephone: "",
            phone: "",
            type: props.role === roles[5] ? "Клиент" : "",
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.keyData && nextProps.isOpened && !this.props.isOpened){
            this.setState({
                ...nextProps.keyData,
            })
        }
        if (!nextProps.isOpened) {
            this.setState({
                name: "",
                key_hash: "",
                balance: 0,
                phone: "",
                organization: "",
                type: nextProps.role === roles[5] ? "Клиент" : "",
            })
        }
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    render(){
        const { classes, onCancel, onSave, isOpened, isNew} = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >{isNew ? "Создание нового" : "Редактирование" } ключа</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <Grid container>
                        <GridItem xs={12} md={6}>
                            <CustomInput
                                labelText="HEX ключа"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.key_hash,
                                    onChange: e => this._changeValue(e, "key_hash")
                                }}
                            />
                            <CustomInput
                                labelText="Имя"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.name,
                                    onChange: e => this._changeValue(e, "name")
                                }}
                            />
                            <CustomInput
                                labelText="Баланс"
                                formControlProps={{
                                    fullWidth: true,
                                    disabled: this.state.type !== "Клиент",
                                }}
                                inputProps={{
                                    value: this.state.balance,
                                    onChange: e => this._changeValue(e, "balance")
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12} md={6}>
                            <CustomInput
                                labelText="Телефон"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.phone,
                                    onChange: e => this._changeValue(e, "phone")
                                }}
                            />
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel>Тип</InputLabel>
                                <Select
                                    value={this.state.type}
                                    onChange={(e) => this._changeValue(e, "type")}
                                    inputProps={{
                                        name: 'type',
                                    }}
                                    className={classes.select}
                                    disabled={this.props.role === roles[5]}
                                >
                                    {this.props.types.map((type, id) => (
                                        <MenuItem key={id} value={type.name}>{type.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <CustomInput
                                labelText="Цена по ключу"
                                formControlProps={{
                                    fullWidth: true,
                                    disabled: this.state.type !== "Клиент",
                                }}
                                inputProps={{
                                    value: this.state.liter_price,
                                    onChange: e => this._changeValue(e, "liter_price")
                                }}
                            />
                        </GridItem>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave(this.state)}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

KeyDialog.propTypes = {
    isOpened: PropTypes.bool,
    isNew: PropTypes.bool,
    keyData: PropTypes.object,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    organizations: PropTypes.arrayOf(PropTypes.string),
    types: PropTypes.array,
};

export default withStyles(modalStyle)(KeyDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/KeyDialog.jsx